import React, { useRef, useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
/* eslint-disable */
const FAQ = ({ faqs }) => {
  const data = useRef(
    Array.from({ length: faqs?.data?.length }, i => (i = false))
  )
  const [isExpanded, setIsExpanded] = useState(data)

  const toggleFAGTab = index => {
    data.current[index] = !isExpanded[index]
    setIsExpanded([...data.current])
  }

  return (
    <div className="max-w-screen-lg mx-auto px-7">
      <div className="tabs last:border-b">
        {faqs?.data?.map((faq, index) => {
          const { answer, question } = faq.attributes
          return (
            <div key={`faq-${index}`}>
              <button
                onClick={() => toggleFAGTab(index)}
                className="font-cardo w-full block border-t py-5 flex text-left"
              >
                <p
                  className="w-11/12"
                  dangerouslySetInnerHTML={{ __html: question }}
                ></p>
                <div className="mt-1 px-5 ml-auto">
                  {!isExpanded[index] ? (
                    <StaticImage
                      className="cursor-pointer"
                      src="../../static/images/icon/arrow-down.svg"
                      alt="arrow"
                    />
                  ) : (
                    <StaticImage
                      className="cursor-pointer mt-2 mr-1"
                      src="../../../src/static/images/icon/close.svg"
                      alt="arrow"
                    />
                  )}
                </div>
              </button>
              {isExpanded[index] && (
                <div className="tab-content font-montserrat--18">
                  <p dangerouslySetInnerHTML={{ __html: answer }}></p>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FAQ
